import api from '@/services/Api';

class Awards {
  /**
   * @returns {AxiosPromise<any>}
   */
  static all(params = []) {
    return api.get('/awards/awards', {
      params,
    });
  }

  /**
   * Create a new IFAC role for Awards
   * @returns {AxiosPromise<any>}
   */
  static createPosition(payload) {
    return api.post('/awards/awards/add-role', payload);
  }

  /**
   * Get a single Award
   * @returns {AxiosPromise<any>}
   */
  static get(id) {
    return api.get(`/awards/awards/${id}`);
  }

  /**
   * Create an Award
   * @returns {AxiosPromise<any>}
   */
  static create(payload) {
    return api.post('/awards/awards', payload);
  }

  /**
   * Update a single Award
   * @returns {AxiosPromise<any>}
   */
  static update(id, payload) {
    return api.put(`/awards/awards/${id}`, payload);
  }

  /**
   * Create a new IFAC role for Awards
   * @returns {AxiosPromise<any>}
   */
  static copy(id, params) {
    return api.post(`/awards/awards/${id}/copy`, params);
  }

  /**
   * Update Award Restrictions
   * @returns {AxiosPromise<any>}
   */
  static updateRestrictions(id, payload) {
    return api.put(`/awards/awards/${id}/restrictions`, payload);
  }

  /**
   * Get Award Forms
   * @returns {AxiosPromise<any>}
   */
  static getForms(awardId) {
    return api.get(`/awards/awards/${awardId}/forms`);
  }

  /**
   * Get Award Nominations
   * @returns {AxiosPromise<any>}
   */
  static getNominations(awardId, payload) {
    return api.get(`/awards/awards/${awardId}/nominations`, {
      params: payload,
    });
  }

  /**
   * Get Award Forms
   * @returns {AxiosPromise<any>}
   */
  static updateForm(awardId, formId, payload) {
    return api.put(`/awards/awards/${awardId}/forms/${formId}`, payload);
  }

  /**
   * @returns {AxiosPromise<any>}
   */
  static reopen(params = {}) {
    return api.post('/awards/awards/reopen', params);
  }

  /**
   * @returns {AxiosPromise<any>}
   */
  static archive(params = {}) {
    return api.post('/awards/awards/archive', params);
  }
}

export default Awards;
